import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * Optimized with https://jakearchibald.github.io/svgomg/
 */
const SVGWeb: React.FC<Props> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" fill="white"/>
    <circle cx="12" cy="12" r="10" stroke="#666666" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="3" y1="7.5" x2="21" y2="7.5" stroke="#666666"/>
    <line x1="3" y1="15.5" x2="21" y2="15.5" stroke="#666666"/>
    <path d="M11 2C7.98151 5.33333 3.75561 14 11 22" stroke="#666666"/>
    <path d="M13 22C16.0185 18.6667 20.2444 10 13 2" stroke="#666666"/>
  </svg>
);

export default SVGWeb;
